export const API_VERSION = "v1.0";
const HOST_URL = `website.nuviotech.co`;
const LIVEBASEURL = `https://api.nuviotech.co`;
const DEVBASEURL = `http://localhost:3800`;
// const DEVBASEURL = `https://cinematic-server-gdc-3.brij.tech`;
// const DEVBASEURL = `http://shringar.brij.tech:3950`;

export const BASEURL =window.location.host === HOST_URL ? LIVEBASEURL : DEVBASEURL;
export const SOCKETURL = BASEURL;
export const IMG_BASEURL = `https://dd3zjslgvteqz.cloudfront.net`;
export const ARENA_TOKEN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjYwN2VkY2MwLTNjODQtNGRhZC1hY2VmLTBjN2FhYjNmMzU1MyIsImlhdCI6MTYwNjg5MzA0MCwiZXhwIjoxNjA5NDg1MDQwfQ.3dkWIqaDYXjJ0Eayq_nL8Q0rbmqfYcyI3NLZbcbKh8Y`;
export const STARCINEMAS_TOKEN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6Ijc1ZDAzZDQwLTJiYTQtNDk5ZC04ZGU0LTY4NTQ4ODIzZDUxNSIsImlhdCI6MTc0NzY0NzQ4MH0.T0IRB_syoeqfZLpe395GM2sE8kYhHDxg7wk6jpfhP6w`;
export const TOKEN = STARCINEMAS_TOKEN;
